export const config = {
    sweden: {
        region: 'sv-se',
        landingPage: true,
        cgPageFeedback: true,
        cgArticleFeedback: true,
        qualtricsArticleFeedback: false,
        qualtricsPageFeedback: false,
        pageFeedbackLanguage: "sv_SE",
        pageFeedbackSegment: "DSC Knowledge Sweden Page Feedback",
        translation:true,
        googleTranslate: false,
        googleAnalytics: false,
        defaultRedirectOnBootstrap: "",
        apiEndPointList: {
            channelMap: "/ivr/getNativeChannelMap",
            sfdcArticles: "/ivr/sfdcKBArticles",
            loginToken: "/ivr/token",
            createCase: "/ivr/createCase",
            attachmentUpload: "/ivr/attachmentUpload",
            updateThumbsUp: "/ivr/updateThumbsUp",
            five9Url: "/ivr/five9",
            createSSoUser: "/ivr/createUser",
            getUser: "/ivr/getUser",
            addProductAccess: "/ivr/addProductAccess",
            searchTitles: "/ivr/search/getTitles",
            getSearchData: "/ivr/search/getSearchData",
            getAllSearchData: "/ivr/search/getAllSearchData",
            getTabDetails: "/ivr/search/getTabDetails",
            getReasonDetails: "/ivr/reasonDetails",
            getCaseStatus: "/ivr/caseStatus",
            updateCaseStatus: "/ivr/updateCaseStatus"
        },
        forms:{
            formFieldsPrivate: 
                [
                    { name: 'name', mandatory: true, label: 'requestForm.Name', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                    { name: 'companyName', mandatory: true, label: 'requestForm.companyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder',error: 'requestForm.companyNameErr', value: '', readonly: false},
                    { name: 'email', mandatory: true, label: 'requestForm.email', type: 'email', placeholder:'requestForm.EmailPlaceholder',error: 'requestForm.emailErr', value: '', readonly: false },
                    { name: 'telephone', mandatory: false, label: 'requestForm.telephoneNum', type: 'tel', placeholder:'requestForm.TelephoneNumberPlaceholder', error: 'requestForm.telephoneNumErr', value: '', readonly: false },
                    { name: 'productName', mandatory: false, label: 'requestForm.productName', type: 'text', placeholder:'requestForm.ProductNamePlaceholder',error: 'requestForm.productNameErr', value: '', readonly: false },
                    { name: 'dunsNum', mandatory: false, label: 'requestForm.dunsNum', type: 'text', placeholder:'requestForm.DunsNumberPlaceholder', error: 'requestForm.dunsNumErr', value: '', readonly: false },
                    { name: 'comments', mandatory: false,  label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder',error: 'requestForm.commentsErr', value: '', readonly: false },
                    { name: 'attachments', mandatory: false,  label: 'requestForm.attachments', type: 'file', placeholder:'requestForm.attachmentsPlaceholder',error: 'requestForm.attachmentneededMsg', value: '', readonly: false }

                ],
                formFieldsBusiness: 
                [
                    { name: 'name', mandatory: true, label: 'requestForm.Name', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                    { name: 'companyName', mandatory: true, label: 'requestForm.companyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder',error: 'requestForm.companyNameErr', value: '', readonly: false},
                    { name: 'email', mandatory: true, label: 'requestForm.email', type: 'email', placeholder:'requestForm.EmailPlaceholder',error: 'requestForm.emailErr', value: '', readonly: false },
                    { name: 'telephone', mandatory: false, label: 'requestForm.telephoneNum', type: 'tel', placeholder:'requestForm.TelephoneNumberPlaceholder', error: 'requestForm.telephoneNumErr', value: '', readonly: false },
                    { name: 'productName', mandatory: false, label: 'requestForm.productName', type: 'text', placeholder:'requestForm.ProductNamePlaceholder',error: 'requestForm.productNameErr', value: '', readonly: false },
                    { name: 'dunsNum', mandatory: false, label: 'requestForm.dunsNum', type: 'text', placeholder:'requestForm.DunsNumberPlaceholder', error: 'requestForm.dunsNumErr', value: '', readonly: false },
                    { name: 'comments', mandatory: false,  label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder',error: 'requestForm.commentsErr', value: '', readonly: false },
                    { name: 'attachments', mandatory: false,  label: 'requestForm.attachments', type: 'file', placeholder:'requestForm.attachmentsPlaceholder',error: 'requestForm.attachmentneededMsg', value: '', readonly: false }

                ],
                additionalFields:[
                    {formFieldsBusiness: ["reasonForContact", "subReason", "caseType", "type", "reason", "recordTypeId"],
                    formFieldsPrivate: ["reasonForContact", "subReason", "caseType", "type", "reason", "recordTypeId"]
                    }
                   ],
                   successPage:{formFieldsPrivate: [ "greatNewsIcon", "greatNews", "caseSubmitted", "caseNumber"],
                   formFieldsBusiness: [ "greatNewsIcon", "greatNews", "caseSubmitted", "caseNumber"]
                },
                miscellaneous:{
                    formFieldsPrivate : ["submissionNote"],
                    formFieldsBusiness : ["submissionNote"],
                    RequestUserToFillFormTxt: false,
                    completeTheFormWithTitle: true


                } 
        },
        searchExternalRedirection: "https://dunsnumberlookup.dnb.com/sv-se",
        websiteLink: "https://www.dnb.com/sv-se/",
        paths : ['private', 'business'], //Add region specific path
        landingPageDetails: {
            "navigationIcon": "look-up-icon-black.svg",
            "navigationUrl": "https://dunsnumberlookup.dnb.com/sv-se",
            "userCards": [{
                "title": "serviceOptionOne",
                "icon": "Primary-icons_customers-team members.svg",
                "navigate": null,
                "clickHandler": "this.navigateToPrivate"
            }, {
                "title": "serviceOptionTwo",
                "icon": "Secondary-icons_network.svg",
                "navigate": null,
                "clickHandler": "this.navigateToBusiness"

            }
            ]
        },
        footerDetails: {
            "privacyLink": "https://www.dnb.co.uk/utility-pages/privacy-policy.html",
            "termsLink": "https://www.dnb.co.uk/utility-pages/terms-of-use.html"
        },
        featureListDetails: {
            hoverableFeatureList: true,
            icons: [
                "Primary-icons_customers-team members.svg",
                "Secondary-icons_network.svg",
                "Secondary-icons_network.svg"
            ],
            iconCss: {height:100,width:100}
        },
        search: {
            articlePreview: true
        },
        dunsLookupRedirectionTxt: "Find a Company or Dun & Bradstreet's D-U-N-S Number?"
    },
    germany: {
        region: 'de-de',
        landingPage: false,
        cgPageFeedback: true,
        cgArticleFeedback: true,
        qualtricsArticleFeedback: false,
        qualtricsPageFeedback: false,
        pageFeedbackLanguage: "de_DE",
        pageFeedbackSegment: "DSC Knowledge Germany Page Feedback",
        translation:true,
        googleTranslate: true,
        googleAnalytics: false,
        defaultRedirectOnBootstrap: "/private",
        apiEndPointList: {
            channelMap: "/ivr/getNativeChannelMap",
            sfdcArticles: "/ivr/sfdcKBArticles",
            loginToken: "/ivr/token",
            createCase: "/ivr/createCase",
            attachmentUpload: "/ivr/attachmentUpload",
            updateThumbsUp: "/ivr/updateThumbsUp",
            five9Url: "/ivr/five9",
            createSSoUser: "/ivr/createUser",
            getUser: "/ivr/getUser",
            addProductAccess: "/ivr/addProductAccess",
            searchTitles: "/ivr/search/getTitles",
            getSearchData: "/ivr/search/getSearchData",
            getAllSearchData: "/ivr/search/getAllSearchData",
            getTabDetails: "/ivr/search/getTabDetails",
            getReasonDetails: "/ivr/reasonDetails",
            getCaseStatus: "/ivr/caseStatus",
            updateCaseStatus: "/ivr/updateCaseStatus"
        },
        forms:{
            formFields: 
                [
                    { name: 'name', mandatory: false, label: 'requestForm.FirstName', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                    { name: 'lastName', mandatory: true, label: 'requestForm.LastName', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                    { name: 'companyName', mandatory: true, label: 'requestForm.companyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder',error: 'requestForm.companyNameErr', value: '', readonly: false},
                    { name: 'email', mandatory: true, label: 'requestForm.email', type: 'email', placeholder:'requestForm.EmailPlaceholder',error: 'requestForm.emailErr', value: '', readonly: false },
                    { name: 'telephone', mandatory: false, label: 'requestForm.telephoneNum', type: 'tel', placeholder:'requestForm.TelephoneNumberPlaceholder', error: 'requestForm.telephoneNumErr', value: '', readonly: false },
                    { name: 'comments', mandatory: true,  label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder',error: 'requestForm.commentsErr', value: '', readonly: false },

                ],
                additionalFields:[
                    {formFields: ["userType"]
                    }
                   ],
                   successPage:{formFields:[ "greatNewsIcon", "greatNews", "caseSubmitted", "caseNumber"] },
                   miscellaneous:{
                    formFieldsPrivate : ["submissionNote"],
                    formFieldsBusiness : ["submissionNote"],
                    RequestUserToFillFormTxt: false,
                    completeTheFormWithTitle: false



                } 

            
        },
        searchExternalRedirection: "https://www.dnb.com/de-de/upik.html",
        websiteLink: "https://www.dnb.com/de-de/",
        paths : ['private'], //Add region specific path
        landingPageDetails: {
            "navigationIcon": "look-up-icon-black.svg",
            "navigationUrl": "https://dunsnumberlookup.dnb.com/sv-se",
            "userCards": [{
                "title": "serviceOptionOne",
                "icon": "Primary-icons_customers-team members.svg",
                "navigate": null,
                "clickHandler": "this.navigateToPrivate"
            }, {
                "title": "serviceOptionTwo",
                "icon": "Secondary-icons_network.svg",
                "navigate": null,
                "clickHandler": "this.navigateToBusiness"

            }
            ]
        },
        footerDetails: {
            "privacyLink": "https://www.dnb.co.uk/utility-pages/privacy-policy.html",
            "termsLink": "https://www.dnb.co.uk/utility-pages/terms-of-use.html"
        },
        featureListDetails: {
            hoverableFeatureList: true,
            icons: [
                "request_icon.png",
                "cloud-upload-icon.png",
                "Access_report.png",
                "brain_solutions.png"
            ],
            iconCss: {height:32,width:32}
        },
        search: {
            articlePreview: true
        },
        dunsLookupRedirectionTxt: "Ein Unternehmen oder die D-U-N-S-Nummer von Dun & Bradstreet finden?"

    },
    norway: {
        region: 'no-no',
        landingPage: true,
        cgPageFeedback: true,
        cgArticleFeedback: true,
        qualtricsArticleFeedback: false,
        qualtricsPageFeedback: false,
        pageFeedbackLanguage: "nn_NO",
        pageFeedbackSegment: "DSC Knowledge Norway Page Feedback",
        translation:true,
        googleTranslate: true,
        googleAnalytics: false,
        defaultRedirectOnBootstrap: "",
        apiEndPointList: {
            channelMap: "/ivr/getNativeChannelMap",
            sfdcArticles: "/ivr/sfdcKBArticles",
            loginToken: "/ivr/token",
            createCase: "/ivr/createCase",
            attachmentUpload: "/ivr/attachmentUpload",
            updateThumbsUp: "/ivr/updateThumbsUp",
            five9Url: "/ivr/five9",
            createSSoUser: "/ivr/createUser",
            getUser: "/ivr/getUser",
            addProductAccess: "/ivr/addProductAccess",
            searchTitles: "/ivr/search/getTitles",
            getSearchData: "/ivr/search/getSearchData",
            getAllSearchData: "/ivr/search/getAllSearchData",
            getTabDetails: "/ivr/search/getTabDetails",
            getReasonDetails: "/ivr/reasonDetails",
            getCaseStatus: "/ivr/caseStatus",
            updateCaseStatus: "/ivr/updateCaseStatus"
        },
        forms:{
            formFieldsNonCustomer: 
                 [
                    { name: 'firstName', mandatory: true, label: 'requestForm.FirstName', type: 'text' , placeholder:'requestForm.NamePlaceholder', error: 'requestForm.firstNameErr', value: ''},
                    { name: 'lastName', mandatory: true, label: 'requestForm.LastName', type: 'text' , placeholder:'requestForm.NamePlaceholder', error: 'requestForm.lastNameErr', value: ''},
                    { name: 'companyName', mandatory: true, label: 'requestForm.CompanyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder', error: 'requestForm.companyNameErr', value: '' },
                    { name: 'email', mandatory: true, label: 'requestForm.Email', type: 'email', placeholder:'requestForm.EmailPlaceholder', value: '', error:"requestForm.emailErr" },
                    { name: 'dunsNum', mandatory: false, label: 'requestForm.dunsNum', type: 'text', placeholder:'requestForm.DunsNumberPlaceholder', error: 'requestForm.dunsNumErr', value: '' },
                    { name: 'organisationNumber', mandatory: true, label: 'requestForm.organisationNumber', type: 'text', placeholder:'requestForm.organisationNumberPlaceholder', error: 'requestForm.organisationNumberErr', value: '' },
                    { name: 'comments', mandatory: true, label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder', error: 'requestForm.commentsErr', value: '' },

                ],
            formFieldsPrivate: 
                [   
                    { name: 'firstName', mandatory: true, label: 'requestForm.FirstName', type: 'text' , placeholder:'requestForm.NamePlaceholder', error: 'requestForm.firstNameErr', value: ''},
                    { name: 'lastName', mandatory: true, label: 'requestForm.LastName', type: 'text' , placeholder:'requestForm.NamePlaceholder',error: 'requestForm.lastNameErr', value: ''},
                    { name: 'dateOfBirth', mandatory: true, label: 'requestForm.dateOfBirth', type: 'date', format: 'dd.mm.yyyy', placeholder:'requestForm.dateOfBirthPlaceHolder', error: 'requestForm.dateOfBirthErr', value: '' },
                    { name: 'email', mandatory: true, label: 'requestForm.Email', type: 'email', placeholder:'requestForm.EmailPlaceholder', value: '', error:"requestForm.emailErr" },
                   { name: 'postalCode', mandatory: true, label: 'requestForm.postalCode', type: 'text', placeholder:'requestForm.postalCodePlaceHolder', error: 'requestForm.postalCodeErr', value: '', maxlength: 4 },
                   { name: 'comments', mandatory: true, label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder', error: 'requestForm.commentsErr', value: '' }
               ],
               additionalFields:[
                {formFieldsNonCustomer: ["userType"], formFieldsPrivate: ["userType"]
                }
               ],
               successPage: { formFieldsNonCustomer :[ "greatNewsIcon","thanksForInquiry", "getBackInOneBD"],
               formFieldsPrivate :[ "greatNewsIcon","thanksForInquiry", "getBackInThreeBD"]           
               },
               miscellaneous:{
                formFieldsPrivate : [""],
                formFieldsNonCustomer : [""],
                RequestUserToFillFormTxt: true,
                completeTheFormWithTitle: false



            }
            },
        searchExternalRedirection: "https://dunsnumberlookup.dnb.com/no-no",
        websiteLink: "https://www.dnb.com/no/",
        paths : ['private', 'non-customer', ''], //Add region specific path
        landingPageDetails: {
            "navigationIcon": "look-up-icon-black.svg",
            "navigationUrl": "https://dunsnumberlookup.dnb.com/no-no",
            "userCards": [{
                "title": "serviceOptionOne",
                "icon": "Private_icon.png",
                "navigate": null,
                "clickHandler": "this.navigateToPrivate"
            }, {
                "title": "serviceOptionFour",
                "icon": "Primary-icons_customers-team members.svg",
                "navigate": null,
                "clickHandler": "this.navigateNonCustomer"

            }, {
                "title": "serviceOptionTwo",
                "icon": "Business_icon.png",
                "navigate": "https://www.dnb.com/no/kontakt/kundeservice-bedrift.html",
                "clickHandler": "this.navigateToPrivate"
            }
            ]
        },
        footerDetails: {
            "websiteLink": "https://www.dnb.com/no/",
            "privacyLink": "https://www.dnb.com/no/personvern-og-datasikkerhet.html",
            "termsLink": "https://www.dnb.com/no/terms-of-use.html"
        },
        featureListDetails: {
            hoverableFeatureList: true,
            icons: [
                "Primary-icons_customers-team members.svg",
                "Secondary-icons_network.svg",
                "Secondary-icons_network.svg",
                "Primary-icons_customers-team members.svg"
            ],
            iconCss: {height:100,width:100}
        },
        search: {
            articlePreview: true
        },
        dunsLookupRedirectionTxt: "Finne et firma eller Dun & Bradstreets D-U-N-S-nummer?"

    },
    finland: {
        region: 'fi-fi',
        landingPage: true,
        cgPageFeedback: true,
        cgArticleFeedback: true,
        qualtricsArticleFeedback: false,
        qualtricsPageFeedback: false,
        pageFeedbackLanguage: "fi_FI",
        pageFeedbackSegment: "DSC Knowledge Finland Page Feedback",
        translation:true,
        googleTranslate: true,
        googleAnalytics: false,
        defaultRedirectOnBootstrap: "",
        apiEndPointList: {
            channelMap: "/ivr/getNativeChannelMap",
            sfdcArticles: "/ivr/sfdcKBArticles",
            loginToken: "/ivr/token",
            createCase: "/ivr/createCase",
            attachmentUpload: "/ivr/attachmentUpload",
            updateThumbsUp: "/ivr/updateThumbsUp",
            five9Url: "/ivr/five9",
            createSSoUser: "/ivr/createUser",
            getUser: "/ivr/getUser",
            addProductAccess: "/ivr/addProductAccess",
            searchTitles: "/ivr/search/getTitles",
            getSearchData: "/ivr/search/getSearchData",
            getAllSearchData: "/ivr/search/getAllSearchData",
            getTabDetails: "/ivr/search/getTabDetails",
            getReasonDetails: "/ivr/reasonDetails",
            getCaseStatus: "/ivr/caseStatus",
            updateCaseStatus: "/ivr/updateCaseStatus"
        },
        forms:{
            formFieldsNonCustomer: 
                 [
                    { name: 'name', mandatory: true, label: 'requestForm.Name', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                    { name: 'organisationNumber', mandatory: true, label: 'requestForm.organisationNumber', type: 'text', placeholder:'requestForm.organisationNumberPlaceholder', error: 'requestForm.organisationNumberErr', value: '' },
                    { name: 'companyName', mandatory: false, label: 'requestForm.CompanyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder', error: 'requestForm.companyNameErr', value: '' },
                    { name: 'email', mandatory: true, label: 'requestForm.Email', type: 'email', placeholder:'requestForm.EmailPlaceholder', value: '', error:"requestForm.emailErr" },
                    { name: 'dunsNum', mandatory: true, label: 'requestForm.dunsNum', type: 'text', placeholder:'requestForm.DunsNumberPlaceholder', error: 'requestForm.dunsNumErr', value: '' },
                    { name: 'comments', mandatory: true, label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder', error: 'requestForm.commentsErr', value: '' },
                    { name: 'attachments', mandatory: false,  label: 'requestForm.attachments', type: 'file', placeholder:'requestForm.attachmentsPlaceholder',error: 'requestForm.attachmentneededMsg', value: '', readonly: false }
                ],
            formFieldsPrivate: 
                [
                    { name: 'name', mandatory: true, label: 'requestForm.Name', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                    { name: 'dateOfBirth', mandatory: true, label: 'requestForm.dateOfBirth', type: 'date', format: 'dd.mm.yyyy', placeholder:'requestForm.dateOfBirthPlaceHolder', error: 'requestForm.dateOfBirthErr', value: '' },
                    { name: 'email', mandatory: false, label: 'requestForm.Email', type: 'email', placeholder:'requestForm.EmailPlaceholder', value: '', error:"requestForm.emailErr" },
                   { name: 'postalCode', mandatory: true, label: 'requestForm.postalCode', type: 'text', placeholder:'requestForm.postalCodePlaceHolder', error: 'requestForm.postalCodeErr', value: '', maxlength: 5, minlength: 5 },
                   { name: 'comments', mandatory: true, label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder', error: 'requestForm.commentsErr', value: '' },
                   { name: 'attachments', mandatory: false,  label: 'requestForm.attachments', type: 'file', placeholder:'requestForm.attachmentsPlaceholder',error: 'requestForm.attachmentneededMsg', value: '', readonly: false }
               ],
               additionalFields:[
                {formFieldsNonCustomer: ["userType", "recordTypeId", "reasonForContact", "subReason"], formFieldsPrivate: ["userType", "recordTypeId", "reasonForContact", "subReason"]
                }
               ],
               successPage: { formFieldsNonCustomer :[ "greatNewsIcon", "greatNews", "caseSubmitted", "caseNumber"],
               formFieldsPrivate :[ "greatNewsIcon", "greatNews", "caseSubmitted", "caseNumber"]          
               },
               miscellaneous:{
                formFieldsPrivate : [""],
                formFieldsNonCustomer : [""],
                RequestUserToFillFormTxt: true,
                completeTheFormWithTitle: false



            }
            },
        searchExternalRedirection: "https://dunsnumberlookup.dnb.com/fi-fi",
        websiteLink: "https://www.dnb.com/fi/",
        paths : ['private', 'non-customer', ''], //Add region specific path
        landingPageDetails: {
            "navigationIcon": "look-up-icon-black.svg",
            "navigationUrl": "https://dunsnumberlookup.dnb.com/fi-fi",
            "userCards": [{
                "title": "serviceOptionOne",
                "icon": "Private_icon.png",
                "navigate": null,
                "clickHandler": "this.navigateToPrivate"
            }, {
                "title": "serviceOptionFour",
                "icon": "Primary-icons_customers-team members.svg",
                "navigate": null,
                "clickHandler": "this.navigateNonCustomer"

            }, {
                "title": "serviceOptionFive",
                "icon": "Business_icon.png",
                "navigate": "https://www.dnb.com/fi-fi/yhteystiedot.html",
                "clickHandler": "this.navigateToPrivate"
            }
            ]
        },
        footerDetails: {
            "websiteLink": "https://www.dnb.com/fi/",
            "privacyLink": "https://www.dnb.co.uk/utility-pages/privacy-policy.html",
            "termsLink": "https://www.dnb.co.uk/utility-pages/terms-of-use.html"
        },
        featureListDetails: {
            hoverableFeatureList: true,
            icons: [
                "Primary-icons_customers-team members.svg",
                "Secondary-icons_network.svg",
                "Secondary-icons_network.svg",
                "Primary-icons_customers-team members.svg"
            ],
            iconCss: {height:100,width:100}
        },
        search: {
            articlePreview: true
        },
        dunsLookupRedirectionTxt: "Etsitkö yritystä tai Dun & Bradstreetin D-U-N-S-numeroa?"

    },
    denmark: {
        region: 'da-dk',
        landingPage: true,
        cgPageFeedback: true,
        cgArticleFeedback: true,
        qualtricsArticleFeedback: false,
        qualtricsPageFeedback: false,
        pageFeedbackLanguage: "da_DK",
        pageFeedbackSegment: "DSC Knowledge Denmark Page Feedback",
        translation:true,
        googleTranslate: true,
        googleAnalytics: false,
        defaultRedirectOnBootstrap: "",
        apiEndPointList: {
            channelMap: "/ivr/getNativeChannelMap",
            sfdcArticles: "/ivr/sfdcKBArticles",
            loginToken: "/ivr/token",
            createCase: "/ivr/createCase",
            attachmentUpload: "/ivr/attachmentUpload",
            updateThumbsUp: "/ivr/updateThumbsUp",
            five9Url: "/ivr/five9",
            createSSoUser: "/ivr/createUser",
            getUser: "/ivr/getUser",
            addProductAccess: "/ivr/addProductAccess",
            searchTitles: "/ivr/search/getTitles",
            getSearchData: "/ivr/search/getSearchData",
            getAllSearchData: "/ivr/search/getAllSearchData",
            getTabDetails: "/ivr/search/getTabDetails",
            getReasonDetails: "/ivr/reasonDetails",
            getCaseStatus: "/ivr/caseStatus",
            updateCaseStatus: "/ivr/updateCaseStatus"
        },
        forms:{
            formFieldsNonCustomer: 
                 [
                    { name: 'firstName', mandatory: true, label: 'requestForm.FirstName', type: 'text' , placeholder:'requestForm.NamePlaceholder', error: 'requestForm.firstNameErr', value: ''},
                    { name: 'lastName', mandatory: true, label: 'requestForm.LastName', type: 'text' , placeholder:'requestForm.NamePlaceholder',error: 'requestForm.lastNameErr', value: ''},
                    { name: 'organisationNumber', mandatory: true, label: 'requestForm.organisationNumber', type: 'text', placeholder:'requestForm.organisationNumberPlaceholder', error: 'requestForm.organisationNumberErr', value: ''},
                    { name: 'companyName', mandatory: false, label: 'requestForm.CompanyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder', error: 'requestForm.companyNameErr', value: '' },
                    { name: 'email', mandatory: true, label: 'requestForm.Email', type: 'email', placeholder:'requestForm.EmailPlaceholder', value: '', error:"requestForm.emailErr" },
                    { name: 'dunsNum', mandatory: true, label: 'requestForm.dunsNum', type: 'text', placeholder:'requestForm.DunsNumberPlaceholder', error: 'requestForm.dunsNumErr', value: '' },
                    { name: 'comments', mandatory: true, label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder', error: 'requestForm.commentsErr', value: '' }
                ],
            formFieldsPrivate: 
                [
                    { name: 'firstName', mandatory: true, label: 'requestForm.FirstName', type: 'text' , placeholder:'requestForm.NamePlaceholder', error: 'requestForm.firstNameErr', value: ''},
                    { name: 'lastName', mandatory: true, label: 'requestForm.LastName', type: 'text' , placeholder:'requestForm.NamePlaceholder',error: 'requestForm.lastNameErr', value: ''},
                    { name: 'dateOfBirth', mandatory: true, label: 'requestForm.dateOfBirth', type: 'date', format: 'dd.mm.yyyy', placeholder:'requestForm.dateOfBirthPlaceHolder', error: 'requestForm.dateOfBirthErr', value: '' },
                    { name: 'email', mandatory: false, label: 'requestForm.Email', type: 'email', placeholder:'requestForm.EmailPlaceholder', value: '', error:"requestForm.emailErr" },
                   { name: 'postalCode', mandatory: true, label: 'requestForm.postalCode', type: 'text', placeholder:'requestForm.postalCodePlaceHolder', error: 'requestForm.postalCodeErr', value: '', maxlength: 4, minlength: 4 },
                   { name: 'comments', mandatory: true, label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder', error: 'requestForm.commentsErr', value: '' }
               ],
               additionalFields:[
                {formFieldsNonCustomer: ["userType"], formFieldsPrivate: ["userType"]
                }
               ],
               successPage: { formFieldsNonCustomer :[ "greatNewsIcon","thanksForInquiry", "getBackInOneBD"],
               formFieldsPrivate :[ "greatNewsIcon","thanksForInquiry", "getBackInTwoBD"]                
               },
               miscellaneous:{
                formFieldsPrivate : [""],
                formFieldsNonCustomer : [""],
                RequestUserToFillFormTxt: true,
                completeTheFormWithTitle: false



            }
            },
        searchExternalRedirection: "https://dunsnumberlookup.dnb.com/dk-dk",
        websiteLink: "https://www.dnb.com/dk",
        paths : ['private', 'non-customer', ''], //Add region specific path
        landingPageDetails: {
            "navigationIcon": "look-up-icon-black.svg",
            "navigationUrl": "https://dunsnumberlookup.dnb.com/dk-dk",
            "userCards": [{
                "title": "serviceOptionOne",
                "icon": "Private_icon.png",
                "navigate": null,
                "clickHandler": "this.navigateToPrivate"
            }, {
                "title": "serviceOptionTwo",
                "icon": "Business_icon.png",
                "navigate": null,
                "clickHandler": "this.navigateNonCustomer"

            }, {
                "title": "serviceOptionThree",
                "icon": "Primary-icons_customers-team members.svg",
                "navigate": "https://www.dnb.com/da-dk/om-os/kontakt.html",
                "clickHandler": "this.navigateToPrivate"
            }
            ]
        },
        footerDetails: {
            "websiteLink": "https://www.dnb.com/da/",
            "privacyLink": "https://www.dnb.com/da-dk/personvern-og-datasikkerhet.html",
            "termsLink": "https://www.dnb.com/da-dk/terms-of-use.html"
        },
        featureListDetails: {
            hoverableFeatureList: true,
            icons: [
                "plane.png",
                "business.png",
                "cloud-upload-icon.png",
                "customer-support.png",
                "Access_report.png"
            ],
            iconCss: {height:60,width:60}
        },
        search: {
            articlePreview: true
        },
        dunsLookupRedirectionTxt: "Leder du efter et firma- eller Dun & Bradstreet D-U-N-S-nummer?"

    },
    us: {
        region: 'en-us',
        landingPage: false,
        cgPageFeedback: false,
        cgArticleFeedback: false,
        qualtricsArticleFeedback: true,
        customqualtricsArticleFeedback: false, //set to true post external api integration
        //uncomment for future release
        qualtricsPageFeedback: true,
        pageFeedbackLanguage: "en_GB",
        pageFeedbackSegment: "DSC Knowledge US Page Feedback",
        translation:false,
        googleTranslate: false,
        googleAnalytics: true,
        defaultRedirectOnBootstrap: "",
        apiEndPointList: {
            channelMap: "/ivr/getChannelMap",
            sfdcArticles: "/ivr/sfdcKBArticles",
            loginToken: "/ivr/token",
            createCase: "/ivr/createCase",
            attachmentUpload: "/ivr/attachmentUpload",
            updateThumbsUp: "/ivr/updateThumbsUp",
            five9Url: "/ivr/five9",
            createSSoUser: "/ivr/createUser",
            getUser: "/ivr/getUser",
            addProductAccess: "/ivr/addProductAccess",
            searchTitles: "/ivr/search/getTitles",
            getSearchData: "/ivr/search/getSearchData",
            getAllSearchData: "/ivr/search/getAllSearchData",
            getTabDetails: "/ivr/search/getTabDetails",
            getReasonDetails: "/ivr/reasonDetails",
            getCaseStatus: "/ivr/caseStatus",
            updateCaseStatus: "/ivr/updateCaseStatus"
        },
        forms:{
            formFields:   [
                { name: 'Name', mandatory: true, label: 'requestForm.Name', type: 'text', placeholder:'requestForm.NamePlaceholder', error: 'requestForm.nameError', value: '', readonly: false}, // label is translation key
                { name: 'companyName', mandatory: true, label: 'requestForm.companyName', type: 'text', placeholder:'requestForm.CompanyNamePlaceholder',error: 'requestForm.companyNameErr', value: '', readonly: false},
                { name: 'dunsNum', mandatory: false, label: 'requestForm.dunsNum', type: 'text', placeholder:'requestForm.DunsNumberPlaceholder', error: 'requestForm.dunsNumErr', value: '', readonly: false },
                { name: 'email', mandatory: true, label: 'requestForm.email', type: 'email', placeholder:'requestForm.EmailPlaceholder',error: 'requestForm.emailErr', value: '', readonly: false },
                { name: 'telephoneNum', mandatory: false, label: 'requestForm.telephoneNum', type: 'tel', placeholder:'requestForm.TelephoneNumberPlaceholder', error: 'requestForm.telephoneNumErr', value: '', readonly: false },
                { name: 'productName', mandatory: false, label: 'requestForm.productName', type: 'text', placeholder:'requestForm.ProductNamePlaceholder',error: 'requestForm.productNameErr', value: '', readonly: false },
                { name: 'reasonforContact', mandatory: true, label: 'requestForm.reasonForContact', type: 'text', placeholder:'requestForm.reasonForContactPlaceholder', error: 'requestForm.reasonForContactErr', value: '', readonly: false },
                { name: 'subReason', mandatory: true, label: 'requestForm.subReason', type: 'text', placeholder:'requestForm.subReasonPlaceholder',error: 'requestForm.subReasonErr', value: '', readonly: true },
                { name: 'comments', mandatory: true,  label: 'requestForm.comments', type: 'textarea', placeholder:'requestForm.CommentsPlaceholder',error: 'requestForm.commentsErr', value: '', readonly: false },
                { name: 'attachments', mandatory: true,  label: 'requestForm.attachments', type: 'file', placeholder:'requestForm.attachmentsPlaceholder',error: 'requestForm.attachmentneededMsg', value: '', readonly: false }

            ]
        
        },
        searchExternalRedirection: "https://dunsnumberlookup.dnb.com",
        websiteLink: "https://www.dnb.com/",
        paths : ['home', ''], //Add region specific path
        landingPageDetails: {
            "navigationIcon": "look-up-icon-black.svg",
            "navigationUrl": "https://dunsnumberlookup.dnb.com/sv-se",
            "userCards": [{
                "title": "serviceOptionOne",
                "icon": "Primary-icons_customers-team members.svg",
                "navigate": null,
                "clickHandler": "this.navigateToPrivate"
            }, {
                "title": "serviceOptionTwo",
                "icon": "Secondary-icons_network.svg",
                "navigate": null,
                "clickHandler": "this.navigateToBusiness"

            }
            ]
        },
        footerDetails: {
            "privacyLink": "https://www.dnb.com/utility-pages/privacy-policy.html",
            "termsLink": "https://www.dnb.com/utility-pages/terms-of-use.html"
        },
        featureListDetails: {
            hoverableFeatureList: false,
            icons: [
                "solid_paper_plane.png",
                "solid_form_edit.png",
                "solid_users_cog.png",
                "solid_user_secret.png",

            ],
            iconCss: {height:32,width:32}
        },
        search: {
            articlePreview: false
        },
        dunsLookupRedirectionTxt: "Find a Company or Dun & Bradstreet's D-U-N-S Number?"

    }
};
